<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000px" scrollable>
      <template v-slot:activator="{ on }">
        <!-- <div v-on="on"> -->
        <div>
          <mf-button disabled icon="add" label="Adicionar Número" />
        </div>
      </template>
      <v-card v-if="dialog">
        <v-card-title><span class="title-preview mb-3">Adicionar número</span></v-card-title>
        <v-card-text> Fluxo de adição de novos números será adicionado em breve! </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddNumberExternalProvider',
  data: () => ({
    dialog: false,
  }),
}
</script>
